<template>
    <div>
        <div class="row border-bottom">
            <div class="col">
                <v-icon v-if="account.configurations.organism !== null" color="success" class="mr-5">
                    check
                </v-icon>
                <v-icon v-else color="error" class="mr-5">
                    clear
                </v-icon>
                <a @click="changeStep(1)">Nom de votre structure</a>
            </div>
            <div class="col">
                <div v-if="account.configurations.organism !== null">
                    {{ account.configurations.organism.value }}
                </div>
                <div v-else class="d-flex justify-content-between">
                    <div style="color: red; font-weight: bold" class="mt-auto mb-auto">
                        Non configuré
                    </div>
                </div>
            </div>
        </div>
        <div class="row border-bottom">
            <div class="col">
                <v-icon v-if="account.configurations.cgu !== null" color="success" class="mr-5">
                    check
                </v-icon>
                <v-icon v-else color="error" class="mr-5">
                    clear
                </v-icon>
                <a @click="changeStep(1)">Vos CGU</a>
            </div>
            <div class="col">
                <div v-if="account.configurations.cgu !== null">
                    <a :href="account.configurations.cgu.doc_url" target="_blank" class="account.configurations-link">
                        Voir mes CGU
                    </a>
                </div>
                <div v-else class="d-flex justify-content-between">
                    <div style="color: red; font-weight: bold" class="mt-auto mb-auto">
                        Non configuré
                    </div>
                </div>
            </div>
        </div>
        <div class="row border-bottom">
            <div class="col">
                <v-icon v-if="account.configurations.logo !== null" color="success" class="mr-5">
                    check
                </v-icon>
                <v-icon v-else color="error" class="mr-5">
                    clear
                </v-icon>
                <a @click="changeStep(1)">Votre logo</a>
            </div>
            <div class="col">
                <div v-if="account.configurations.logo !== null">
                    <a :href="account.configurations.logo.doc_url" target="_blank" class="account.configurations-link">
                        Voir mon logo
                    </a>
                </div>
                <div v-else class="d-flex justify-content-between">
                    <div style="color: red; font-weight: bold" class="mt-auto mb-auto">
                        Non configuré
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-5">
            <div class="col">
                <v-icon v-if="account.configurations.oneSender" color="success" class="mr-5">
                    check
                </v-icon>
                <v-icon v-else color="error" class="mr-5">
                    clear
                </v-icon>
                <a @click="changeStep(3)">Au moins une boîte d'envoi validée</a>
            </div>
            <div class="col">
                <div v-if="account.configurations.oneSender">
                    <div v-for="sender in account.configurations.senders">
                        <span v-if="sender.delivery === 'SUCCESS'">
                            {{ sender.emailable.email }}
                        </span>
                    </div>
                </div>
                <div v-else class="d-flex justify-content-between">
                    <div style="color: red; font-weight: bold" class="mt-auto mb-auto">
                        Non configuré
                    </div>
                </div>
            </div>
        </div>

        <div class="text-end mt-5">
            <v-btn class="default-button mb-1" @click="save">Finaliser</v-btn>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
    name: "Finalize",
    methods: {
        ...mapMutations('account', ['setUser']),
        hasOneValidSender() {
            let has = false

            this.account.senders.forEach(sender => {
                if (sender.delivery === 'SUCCESS') {
                    has = true
                }
            })

            return has
        },
        isValidOrganism() {
            return this.account.configurations.organism !== null &&
                this.account.configurations.cgu !== null &&
                this.account.configurations.logo !== null
        },
        changeStep(step) {
            this.$global.$emit('change-step', step)
        },
        save() {
            this.$global.loading = true

            this.$http.get('auth/onboarding/complete').then(res => {
                this.$global.loading = false

                this.setUser(res.body.data.user)

                this.$router.push({ path: '/home' })
            })
        }
    },
    computed: {
        ...mapState('account', ['account', 'senders']),
        isValid() {
            return this.isValidOrganism() &&
                this.hasOneValidSender()
        }
    }
}
</script>